<template>
  <div class="addressBox" >
     <el-table :data="[{}]" ref="table"  bordersize="mini" class="tableBox" style="" max-height="500px"  center border>
     <el-table-column label="车牌号" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>车牌号</div>
        </template>
        <template >
          <div style="display:flex;align-items: center;">
            <el-form-item label=""   class="table_error" >
              <el-autocomplete class="inline-input" v-model.trim="goodform.plateNumber" :popper-append-to-body="false"
                  :fetch-suggestions="searchFn1" value-key="id" @select="dbSelected1" @blur="carBlurFn" popper-class="xiala">
                    <template slot-scope="{ item }">
                        <div style="position: relative;">
                        <div class="name">{{ item.vhcNo }} / {{ [ "外协", "自有" ][item.vhcClassify-1]}}</div>
                      </div>
                  </template>
              </el-autocomplete>
            </el-form-item>
            <i  class="el-icon-circle-plus-outline el-input__icon"  slot="suffix"  @click="addVL">  </i>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="车牌颜色" min-width="120">
        <template >
          <div>
            <el-form-item label=""    class="table_error" >
              {{goodform.licensePlateColorName}}
              <!-- <el-select  v-model="goodform.licensePlateColor" filterable placeholder="请选择">
                <el-option v-for="item in clys" :key="item.value" :label="item.label"  :value="item.value"  ></el-option>
              </el-select> -->
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="能源类型" min-width="120">
        <template >
          <div>
            <el-form-item label=""    class="table_error" >
              {{goodform.energyTypeName}}
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="司机" min-width="120">
        <template slot="header" >
          <div><span class="red">*</span>司机</div>
        </template>
        <template >
          <div style="display:flex;align-items: center;">
            <el-form-item label=""   class="table_error" >
             <el-autocomplete class="inline-input" v-model.trim="goodform.driverName" :popper-append-to-body="false"
                :fetch-suggestions="searchFn2" value-key="id" @select="dbSelected2" @blur="sijiBlurFn" popper-class="xiala">
                  <template slot-scope="{ item }">
                      <div style="position: relative;">
                      <div class="name">{{ item.name }} / {{ [ "外协", "自有" ][item.driverClassify-1]}}{{item.mobile}}</div>
                    </div>
                </template>
            </el-autocomplete>
            </el-form-item>
            <i  class="el-icon-circle-plus-outline el-input__icon"  slot="suffix"  @click="addsiji">  </i>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="联系电话" min-width="120">
        <template slot="header" >
          <div>联系电话</div>
        </template>
        <template >
          <div>
            <el-form-item label=""  class="table_error"  >
              {{goodform.driverPhone}}
              <!-- <el-input  placeholder=""    maxlength="12" v-model="goodform.driverPhone"  ></el-input> -->
            </el-form-item>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="身份证号" min-width="120">
        <template >
          <div>
            <el-form-item label=""  class="table_error"  >
              {{goodform.idNumber}}
              <!-- <el-input  placeholder=""    maxlength="12" v-model="goodform.idNumber"  ></el-input> -->
            </el-form-item>
          </div>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top:20px"></div>
     <el-form-item label="承运商:" prop="generalCarrier" class="width1" :rules="[{ required: true, message: '请选择承运商', trigger: 'blur' }]" >
      <el-select  v-model="goodform.generalCarrier" filterable placeholder="请选择" clearable   @change="generalCarrierChange">
        <el-option v-for="item in CYSList" :label="item.customerName" :value="item.customerName" :key="item.id"></el-option>
      </el-select>
    </el-form-item>
    <addDriver v-if="addDriverFlag" :addDriverFlag.sync='addDriverFlag' @cDaddFn="dbSelected2"></addDriver>
    <addVehicle v-if="addVehicleFlag" :addVehicleFlag.sync='addVehicleFlag' @cVIaddFn="dbSelected1"></addVehicle>
  </div>
</template>

<script>
import { cDlist, cVIlist, getWayForPlateNumber, findCustomerInfoList, findDriverInfoById } from '@/api/newTMS'
import { selectTMSTenantListByCustom } from '@/api/newCrm'
import addDriver from '@/views/newTMS/publicFiles/wayAndOrder/addDriver.vue'
import addVehicle from '@/views/newTMS/publicFiles/wayAndOrder/addVehicle.vue'
import { toFixed } from '@/utils/util'
export default {
  components: {
    addDriver, addVehicle
  },
  name: 'shouru',
  props: {
    goodform: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      CPYSlist: [],
      NYLXlist: [],
      CYSList: [],
      XZCLflag: false,
      searchFrom1: {
        pageNo: 1,
        pageSize: 1000
      },
      total2: 0,
      XZSJflag: false,
      searchFrom2: {
        pageNo: 1,
        pageSize: 1000
      },
      addDriverFlag: false,
      addVehicleFlag: false,
      fuwufeilv: null,
      gongzishuilv: null,
      isWuxian: null
    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    findCustomerInfoList({ businessType: 2 }).then(res => {
      selectTMSTenantListByCustom(res).then(res1 => {
        this.CYSList = res1
      })
    })
  },
  methods: {
    // 承运商改变
    generalCarrierChange (e) {
      if (e) {
        let json = this.CYSList.filter(item => item.customerName == this.goodform.generalCarrier)
        this.goodform.generalTaxId = json[0].customerTaxId
        this.goodform.generalCode = json[0].tenantCode
        this.goodform.generalPeriodDays = json[0].periodDays
        this.goodform.generalInvoiceDays = json[0].invoiceDays
        this.goodform.generalPeriodDaysType = json[0].periodDaysType
        this.$set(this.goodform, 'collectionType', 1)
        this.$set(this.goodform, 'expenditurePattern', json[0].settlementType)
        this.$set(this.goodform, 'expenditurePatternName', json[0].settlementTypeName)
        this.$set(this.goodform, 'reverseCountFlag', json[0].reverseCountFlag)
        this.gongzishuilv = json[0].payrollTaxPoint
        this.fuwufeilv = json[0].serviceRate
        if (this.isWuxian == null && this.goodform.driverId) { // 如果是回显过来没有值。所以走一遍接口
          findDriverInfoById({ id: this.goodform.driverId }).then(res => {
            this.isWuxian = res.fiveInsurances == '1'
            this.$set(this.goodform, 'serviceRate', this.isWuxian ? this.gongzishuilv : this.fuwufeilv)
          })
        } else {
          this.$set(this.goodform, 'serviceRate', this.isWuxian ? this.gongzishuilv : this.fuwufeilv)
        }
        this.$set(this.goodform, 'freightTaxRate', json[0].taxRate)
      } else {
        this.$set(this.goodform, 'onlineFlag', null)
        this.$set(this.goodform, 'reverseCountFlag', null)
        this.$set(this.goodform, 'serviceRate', 0)
        this.goodform.generalTaxId = null
        this.goodform.generalCode = null
        this.goodform.generalPeriodDays = null
        this.$set(this.goodform, 'payer', null)
        this.$set(this.goodform, 'payerTaxId', null)
        this.$set(this.goodform, 'payerCode', null)
        this.goodform.generalPeriodDaysType = ''
        this.$set(this.goodform, 'WHJKflag', false)
      }
    },
    carBlurFn () {
      if (!this.goodform.vehicleId) {
        this.$set(this.goodform, 'plateNumber', '')
      }
    },
    sijiBlurFn () {
      if (!this.goodform.driverId) {
        this.$set(this.goodform, 'driverName', '')
      }
    },
    dbSelected1 (row) {
      this.$set(this.goodform, 'vehicleId', row.id)
      if (row.vhcNoColour == -1) {
        this.$set(this.goodform, 'licensePlateColorName', '其他')
      } else {
        this.$set(this.goodform, 'licensePlateColorName', ['蓝色', '黄色', '白色', '黑色', '绿色', '渐变绿', '黄绿色', '农黄色', '农绿色'][row.vhcNoColour - 1])
      }
      this.$set(this.goodform, 'plateNumber', row.vhcNo)
      this.$set(this.goodform, 'licensePlateColor', row.vhcNoColour)
      this.$set(this.goodform, 'vehicleType', row.vhcTypeId)
      this.$set(this.goodform, 'vehicleTypeName', row.vhcTypeName)
      this.$set(this.goodform, 'energyType', row.energyType)
      this.$set(this.goodform, 'energyTypeName', ['其他', '******', '汽油', '柴油', '天然气', '电'][row.energyType + 1])
      this.$set(this.goodform, 'vehicleOwnership', row.vhcClassify == 2 ? 0 : row.vhcClassify)
      this.$set(this.goodform, 'vehicleOwnershipName', [ '外协', '自有' ][row.vhcClassify - 1])
      getWayForPlateNumber({
        pageNo: 1,
        pageSize: 1,
        plateNumber: row.vhcNo
      }).then(res => {
        if (res.list.length > 0) {
          if (res.list[0].driverId && res.list[0].vehicleId) {
            let json = res.map.driverInfo
            this.$set(this.goodform, 'driverId', res.list[0].driverId)
            this.$set(this.goodform, 'driverName', json.name)
            this.$set(this.goodform, 'driverPhone', json.mobile)
            this.$set(this.goodform, 'idNumber', json.identityNo)
            this.$set(this.goodform, 'driverOwnership', res.map.driverClassify == 2 ? 0 : res.map.driverClassify)
            this.$set(this.goodform, 'driverOwnershipName', [ '外协', '自有' ][res.map.driverClassify - 1])
            // 根据司机获取承运商逻辑
            findDriverInfoById({ id: res.list[0].driverId }).then(res => {
              this.isWuxian = res.fiveInsurances == '1'
              if (res.ext1) {
                this.$set(this.goodform, 'generalCarrier', res.ext1)
                this.generalCarrierChange(res.ext1)
              } else {
                this.$set(this.goodform, 'generalCarrier', null)
                this.generalCarrierChange()
              }
            })
          }
        } else {
          this.$set(this.goodform, 'driverId', '')
          this.$set(this.goodform, 'driverName', '')
          this.$set(this.goodform, 'driverPhone', '')
          this.$set(this.goodform, 'idNumber', '')
          this.$set(this.goodform, 'driverOwnership', '')
          this.$set(this.goodform, 'driverOwnershipName', '')
        }
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    dbSelected2 (row) {
      this.$set(this.goodform, 'driverId', row.id)
      this.$set(this.goodform, 'driverName', row.name)
      this.$set(this.goodform, 'driverPhone', row.mobile)
      this.$set(this.goodform, 'idNumber', row.identityNo)
      this.$set(this.goodform, 'driverOwnership', row.driverClassify == 2 ? 0 : row.driverClassify)
      this.$set(this.goodform, 'driverOwnershipName', [ '外协', '自有' ][row.driverClassify - 1])
      // 根据司机回显供应商
      this.isWuxian = row.fiveInsurances == 1
      if (row.ext1) {
        this.$set(this.goodform, 'generalCarrier', row.ext1)
        this.generalCarrierChange(row.ext1)
      } else {
        this.$set(this.goodform, 'generalCarrier', null)
        this.generalCarrierChange()
      }
      this.XZSJflag = false
    },
    searchFn1 (str, cb) {
      this.$set(this.goodform, 'vehicleId', '')
      this.$set(this.goodform, 'licensePlateColor', '')
      this.$set(this.goodform, 'licensePlateColorName', '')
      this.$set(this.goodform, 'vehicleType', '')
      this.$set(this.goodform, 'vehicleTypeName', '')
      this.$set(this.goodform, 'energyType', '')
      this.$set(this.goodform, 'energyTypeName', '')
      this.$set(this.goodform, 'vehicleOwnership', '')
      this.$set(this.goodform, 'vehicleOwnershipName', '')
      this.searchFrom1.vhcNoLike = str
      // if (this.goodform.generalCarrier) {
      //   this.searchFrom1.vhcClassify = 1
      // } else {
      //   this.searchFrom1.vhcClassify = ''
      // }
      cVIlist(this.searchFrom1).then(res => {
        cb(res.list)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    searchFn2 (str, cb) {
      this.$set(this.goodform, 'driverId', '')
      this.$set(this.goodform, 'driverPhone', '')
      this.$set(this.goodform, 'idNumber', '')
      this.$set(this.goodform, 'driverOwnership', '')
      this.$set(this.goodform, 'driverOwnershipName', '')
      this.searchFrom2.name = str
      // if (this.goodform.generalCarrier) {
      //   this.searchFrom2.driverClassify = 1
      // } else {
      //   this.searchFrom2.driverClassify = ''
      // }
      cDlist(this.searchFrom2).then(res => {
        cb(res.list)
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
          }
        })
      })
    },
    addVL () {
      this.addVehicleFlag = true
    },
    addsiji () {
      this.addDriverFlag = true
    }

  }

}
</script>

<style scoped lang='less'>
.width2 /deep/.el-input__inner{
  width: 100px;
}
/deep/.el-autocomplete-suggestion li{
  padding: 0 10px;
  overflow: auto;
  text-align: left;
}
/deep/.xiala{
  width: 240px!important;
}
/deep/.el-icon-circle-plus-outline{
  font-size: 20px;
  margin-left:6px ;
  color: #bfc0c3;
}
</style>
